module.exports = __webpack_public_path__ + "media/assets/images/landings/iot/screens/portal-04859f3fe62cb9b30b992a56bd089146.png";